import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

export const ImageCustom = styled( GatsbyImage )`
  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    width: auto;
    height: min-content;
  }
`
